<script setup lang="ts">
/**
 * UI-kit component
 * Category: Other
 * Name: RowSlot
 */
import type { RowSlotProps } from '../types/interfaces'

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'RowSlot',
})

withDefaults(defineProps<RowSlotProps>(), {
  required: false,
  is: 'span',
  tooltip: null,
})
</script>

<template>
  <div class="row-slot">
    <div :class="['row-slot__text', { tooltip }]">
      <AppText
        name="body1"
        :tag="is"
        color="slate-500"
      >
        {{ label }}
        <span
          v-if="required"
          class="row-slot__required"
        >*</span>
      </AppText>
      <AppTooltip
        v-if="tooltip"
        :text="tooltip"
        placement="right"
        size="small"
      >
        <AppIcon
          :icon="faCircleInfo"
          size="small"
          color="slate-500"
        />
      </AppTooltip>
    </div>
    <div class="row-slot__content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_row-slot.scss" />
